module.exports = __webpack_public_path__ + "img/04-3-1小图.202a4f15.png";